import { trimAndAddAsterisk } from '../../utility/QueryUtility';
import {
  commonDateParamMappings,
  filterParamMapping,
} from '../common/mappings';

export const claimServiceMappings = [
  ...commonDateParamMappings,
  { path: 'page' },
  { path: 'size' },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: any) => {
      if (orderBy && order) {
        switch (orderBy) {
          case 'closedDate':
          case 'created':
          case 'modified':
          case 'reportedDate':
          case 'incidentDate':
          case 'isThereAnotherClaim':
            return `${orderBy},${order}`;
          default:
            return `${orderBy}.keyword,${order}`;
        }
      }
      return null;
    },
  },
  {
    path: 'search',
    transform: ({ search = '' }) =>
      !search ? search : trimAndAddAsterisk(search),
  },
  filterParamMapping,
  { path: 'searchAfter' },
  { path: 'pageRequested' },
  { path: 'accountId' },
  { path: 'teamIds' },
];
